import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

const NotesListItemSkeleton = () => {
  return (
    <SkeletonTheme baseColor='#f2f2f2'>
      <div
        className={`bg-white box-list-item specific-x-padding-30 specific-bottom-padding-25 specific-top-padding-20 border-general border-grey rounded-15 specific-bottom-margin-20`}
      >
        <div className='d-flex align-items-center justify-content-between specific-bottom-margin-10'>
          <div className='d-flex align-items-center'>
            <p className='paragraph-p1 font-weight-semibold text-light-blue-100 mb-0'>
              <Skeleton height={19} width={120} />
            </p>
          </div>
          <p className='paragraph-p1 text-main-blue-60 mb-0 '>
            <Skeleton height={19} width={115} />
          </p>
        </div>
        <div className='d-inline-block paragraph-p1 font-weight-bold text-main-blue specific-bottom-margin-20'>
          <Skeleton height={19} width={250} />
        </div>
        <div className={`editor-content-preview pb-0 notes-page-list-item-content`}>
          <Skeleton height={19} width={150} />
        </div>
      </div>
    </SkeletonTheme>
  );
};

const NotesListSkeleton = () => {
  return (
    <SkeletonTheme baseColor='#f2f2f2'>
      <div>
        <ul className='policy-list px-0 items-list'>
          {Array(9)
            .fill()
            .map((item, index) => (
              <NotesListItemSkeleton key={index} />
            ))}
        </ul>
      </div>
    </SkeletonTheme>
  );
};

export { NotesListItemSkeleton, NotesListSkeleton };
